export default __webpack_public_path__ + "static/media/fasad_pribici3.e8d0136a.jpg";